import { h, Component } from "preact";
import * as _ from "../components/index.js";
import rulesData from "../data/rules.json";

export default class Rule extends Component {
  render() {
    const { id } = this.props;
    const section = rulesData.sections.find((s) => String(s.id) === String(id));

    if (!section) {
      return (
        <>
          <_.Header title="Правила" backurl="/rules" />
          <section class="menu">
            <p>Раздел не найден.</p>
          </section>
        </>
      );
    }

    return (
      <>
        <_.Header title={section.title} backurl="/rules" />
        <section class="menu rule_view">
          {section.paragraphs.map((p, i) => (
            <div class="rule_para" key={i} dangerouslySetInnerHTML={{ __html: p }} />
          ))}
        </section>
      </>
    );
  }
}
